import React, { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Box, Container, Theme, Typography, Grid } from '@material-ui/core';

interface ProjectsCaseSummaryProps {
  text: string;
}

interface ProjectsCaseSummaryArrayProps {
  textList: Array<ProjectsCaseSummaryProps>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    title: {
      fontWeight: 500,
      color: theme.palette.primary.dark,
    },
    text: {
      marginTop: theme.spacing(4),
    },
    divider: {
      width: '100%',
      height: 1,
      backgroundColor: theme.palette.secondary.light,
      margin: theme.spacing(10, 0),
    },
  });
});

const ProjectsCaseSummary: FC<ProjectsCaseSummaryArrayProps> = ({ textList }) => {
  const classes = useStyles();
  return (
    <Container fixed>
      <Grid container justifyContent="center" direction="row">
        <Grid item lg={8} sm={12}>
          <Typography variant="h4" className={classes.title} data-aos="fade-up">
            Case Summary
          </Typography>
          {textList.map((item, index) => (
            <Typography className={classes.text} key={index} data-aos="fade-up">
              {item.text}
            </Typography>
          ))}
          <Box className={classes.divider} />
        </Grid>
      </Grid>
    </Container>
  );
};
export default ProjectsCaseSummary;
